<template>
	<AppLayout
		:title="campaign.subject"
		:subtitle="subtitle"
		:return-url="route('tools.campaigns.index')"
		:return-label="trans('menu.tools.campaigns')"
	>
		<template #actions>
			<slot name="actions"/>
		</template>
		<slot/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {defineProps, ref, type Ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'

const props = defineProps<{
	subtitle:string,
	campaign:Campaign,
}>()

const campaign:Ref<Campaign> = ref(props.campaign)
</script>